import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyBewk6LzxXDoVhSBSlU8DCpqJaOoLrEz8E",
    authDomain: "movie-eeb2c.firebaseapp.com",
    databaseURL: "https://movie-eeb2c-default-rtdb.firebaseio.com",
    projectId: "movie-eeb2c",
    storageBucket: "movie-eeb2c.appspot.com",
    messagingSenderId: "153214737016",
    appId: "1:153214737016:web:6a1331cb6729507d262b8d",
    measurementId: "G-L50N80DKFP"
  };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;
